<template>
  <div class="Search SearchApp" @click="broadcast('close-autocomplete')">
    <SearchHeader v-if="showHeader" :text="SearchHeaderText"/> <!-- pass text="blah" prop if you want this to appear -->
    <Toolbar />
    <ResultsHeader :toggleDisplay="toggleDisplay"/>
    <Results :display="display"/>
  </div>
</template>

<script>
import Toolbar from '@/components/Toolbar.vue'
import SearchHeader from '@/components/SearchHeader.vue'
import ResultsHeader from '@/components/ResultsHeader.vue'
import Results from '@/components/Results.vue'
import 'url-search-params-polyfill'
import { mapGetters } from 'vuex'

export default {
  name: 'Search',
  components: {
    Toolbar,
    SearchHeader,
    ResultsHeader,
    Results,
  },
  data () {
    return {
      api: 'https://search-api.swiftype.com/api/v1/public/engines/search?engine_key=bBSzVx-LA9Z4yYTf6W-S',
      headers: {
        headers: {
          'Content-Type': 'application/json;charset=UTF-8',
          'Access-Control-Allow-Origin': '*',
          'Accept': 'application/json'
        }
      },
      display: 'grid',
      showHeader: false,
      SearchHeaderText: 'Browse 1,000s of Lesson Plans, Classes, Digital Artifacts, Historical Events, and other NewseumED learning tools.',
    }
  },
  mounted: function () {
    // if (window.location.search === '') {
    //   this.query()
    // } else {
    //   this.query(true)
    // }
    this.query()

    this.listenFor('requery',() => {
      this.query()
    })

    this.listenFor('show-less',() => {
      this.$store.commit('updateCurrentPage', this.currentPage - 1)
      this.query()
    })

    this.listenFor('show-less2',() => {
      this.$store.commit('updateCurrentPage', this.currentPage - 2)
      this.query()
    })

    this.listenFor('show-less3',() => {
      this.$store.commit('updateCurrentPage', this.currentPage - 3)
      this.query()
    })

    this.listenFor('show-more',() => {
      this.$store.commit('updateCurrentPage', this.currentPage + 1)
      this.query()
    })

    this.listenFor('show-more2',() => {
      this.$store.commit('updateCurrentPage', this.currentPage + 2)
      this.query()
    })

    this.listenFor('show-more3',() => {
      this.$store.commit('updateCurrentPage', this.currentPage + 3)
      this.query()
    })

    this.listenFor('show-first',() => {
      this.$store.commit('updateCurrentPage', 1)
      this.query()
    })


    this.listenFor('show-last',() => {
      this.$store.commit('updateCurrentPage', this.resultsData.totalPages)
      this.query()
  })

  },
  computed: {
    ...mapGetters({
      searchTerm: 'getSearchTerm',
      currentPage: 'getCurrentPage',
      resultsItems: 'getResultsItems',
      resultsData: 'getResultsData',
      fullResponse: 'getFullResponse',
      activeFilters: 'getActiveFilters',
      dateFilterFrom: 'getDateFilterFrom',
      dateFilterTo: 'getDateFilterTo',
      facets: 'getFacets',
      initial: 'getInitial',
      newTypeCount: 'getNewTypeCount',
      newTopicsCount: 'getNewTopicsCount',
      newCenturiesCount: 'getNewCenturiesCount',
    })
  },
  watch: {
    searchTerm: function () {
      this.query()
    }
  },
  created: function () {
    this.showHeader = this.isTools()
  },
  methods: {
    newFacetCounts: function (queryData) {
      var $this = this
      // console.log(queryData)
      if (queryData && queryData.filters && queryData.filters.page) {

        if (queryData.filters.page.type) {

          if (queryData.filters.page.type.length > 0) { // this seems wrong
            // var typeData = queryData
            var typeData = JSON.parse(JSON.stringify(queryData))
            // console.log("typedata:")
            // console.log(typeData)
            delete typeData.filters.page.type
            // console.log(typeData)
            this.axios.post(this.api, typeData, this.headers)
            .then(function (response) {
              if (response && response.data && response.data.info && response.data.info.page && response.data.info.page.facets) {
                $this.$store.commit('updateNewTypeCount', response.data.info.page.facets.type)
              }
            })
          }

        }

        if (queryData.filters.page.topics) {
          if (queryData.filters.page.topics.length > 0) {
            // var topicsData = queryData
            var topicsData = JSON.parse(JSON.stringify(queryData))
            // console.log(topicsData)
            delete topicsData.filters.page.topics
            this.axios.post(this.api, topicsData, this.headers)
            .then(function (response) {
              if (response && response.data && response.data.info && response.data.info.page && response.data.info.page.facets) {
                $this.$store.commit('updateNewTopicsCount', response.data.info.page.facets.topics)
              }
            })
          }
        }

        if (queryData.filters.page.centuries) {
          if (queryData.filters.page.centuries.length > 0) {
            // var centuriesData = queryData
            var centuriesData = JSON.parse(JSON.stringify(queryData))
            // console.log(centuriesData)
            delete centuriesData.filters.page.centuries
            this.axios.post(this.api, centuriesData, this.headers)
            .then(function (response) {
              if (response && response.data && response.data.info && response.data.info.page && response.data.info.page.facets) {
                $this.$store.commit('updateNewCenturiesCount', response.data.info.page.facets.centuries)
              }
            })
          }
        }
      } else {
        this.$store.commit('updateNewTypeCount', null)
        this.$store.commit('updateNewTopicsCount', null)
        this.$store.commit('updateNewCenturiesCount', null)
      }

      var typeData = queryData
      var topicsData = queryData
      var centuriesData = queryData

    },
    isTools: function () {
      const searchString = String(window.location.search)
      const args = new URLSearchParams(searchString)

      if (args.has('istools') && args.get('istools') === 'true') {
        return true
      }

      return false
    },
    toggleDisplay: function () {
      if (this.display == 'grid') {
        this.display = 'list'
      }
      else {
        this.display = 'grid'
      }
    },
    getActiveTypeFilters: function () {
      var set = this.activeFilters.filter(el => {
        return el.kind === "type"
      })

      var shortnames = set.map(el=>{
        return el.shortname
      })

      return shortnames.length > 0 ? shortnames : []
    },
    getActiveTopicFilters: function () {
      var set = this.activeFilters.filter(el => {
        return el.kind === "topics"
      })

      var names = set.map(el=>{
        return el.name
      })

      return names.length > 0 ? names : []
    },
    getActiveCenturyFilters: function () {
      var set = this.activeFilters.filter(el => {
        return el.kind === "centuries"
      })

      var names = set.map(el=>{
        return el.shortname;
      })

      return names.length > 0 ? names : []
    },
    getActivePersonFilters: function () {
      var set = this.activeFilters.filter(el => {
        return el.kind === "key_person"
      })

      var names = set.map(el=>{
        return el.name
      })

      return names.length > 0 ? names : []
    },
    getActiveStateFilters: function () {
      var set = this.activeFilters.filter(el => {
        return el.kind === "states"
      })

      var names = set.map(el=>{
        return el.name
      })

      return names.length > 0 ? names : []
    },
    getActiveGradeFilters: function () {
      var set = this.activeFilters.filter(el => {
        return el.kind === "grades"
      })

      var names = set.map(el=>{
        return el.name
      })

      return names.length > 0 ? names : []
    },
    unpackUrl: function () {
      //
    },
    packageUrl: function (data) {
      var fullUrlString = '/search/?'

      if (data.q && data.q !== '') {
        fullUrlString += "q="
        fullUrlString += data.q
        fullUrlString += "&"
      }

      if (data.filters && data.filters.page && data.filters.page && Object.keys(data.filters.page).length > 0) {
        Object.keys(data.filters.page).forEach(key => {
          if (data.filters.page[key] && data.filters.page[key].length > 0) {
            fullUrlString += key
            // fullUrlString += "=["
            fullUrlString += "="

            // data.filters.page[key].forEach(el => {
              fullUrlString += data.filters.page[key].toString()
              // fullUrlString += ","
            // })
            // fullUrlString += "]&"
            fullUrlString += "&"
          }
        })
      }

      if (data.filters && data.filters.page && data.filters.page.date_historical && Object.keys(data.filters.page.date_historical).length > 0) {
        fullUrlString += "date_from=" + data.filters.page.date_historical.from
        fullUrlString += "&date_to=" + data.filters.page.date_historical.to
      }

      history.replaceState({}, 'search', fullUrlString)
    },
    removeUnusedFilters: function (data) {
      if (data.filters && data.filters.page && data.filters.page.type.length === 0) {
        delete data.filters.page.type
      }

      if (data.filters && data.filters.page && data.filters.page.topics.length === 0) {
        delete data.filters.page.topics
      }

      if (data.filters && data.filters.page && data.filters.page.grades.length === 0) {
        delete data.filters.page.grades
      }

      if (data.filters && data.filters.page && data.filters.page.key_person.length === 0) {
        delete data.filters.page.key_person
      }

      if (data.filters && data.filters.page && data.filters.page.states.length === 0) {
        delete data.filters.page.states
      }

      if (data.filters && data.filters.page && data.filters.page.centuries.length === 0) {
        delete data.filters.page.centuries
      }

      if (data.filters && data.filters.page && Object.keys(data.filters.page).length === 0) {
        delete data.filters.page
      }

      if (data.filters && Object.keys(data.filters).length === 0) {
        delete data.filters
      }

      return data
    },
    query: function () {
      var $this = this
      var data

      // Get URL query string params.
      const searchString = String(window.location.search)
      const args = new URLSearchParams(searchString)

      // factor out into this.buildInitialQuery()
      if (this.initial) {
        // this is the initial query, sent as the page loads.
        this.broadcast('initial')
        // Prepare the 'data' variable, which holds all the information we need for our Axios call to the Swiftype API.
        // This branch is for the 'initial' query, which happens only when the page loads. It gets paramters from the URL.

        data = {
          "q": (args.has('q') ? args.get('q') : ''),
          // "engine_key": "bBSzVx-LA9Z4yYTf6W-S",
          "per_page" : 100,
          "facets": {
            "page": ["type", "topics", "centuries", "grades"]
          },
          "page" : $this.currentPage,
          "filters": {
            "page": {
              "type": args.has('type') ? args.get('type').split(',') : [],
              "topics": args.has('topics') ? args.get('topics').split(',') : [],
              "grades": args.has('grades') ? args.get('grades').split(',') : [],
              "key_person": args.has('key_person') ? args.get('key_person').split(',') : [],
              "states": args.has('states') ? args.get('states').split(',') : [],
              "centuries": args.has('centuries') ? args.get('centuries').split(',') : [],
            }
          },
        }

        if (args.has('date_to') || args.has('date_from')) {
          if (!data.filters) {
            data.filters = {}

            if (!data.filters.page) {
              data.filters.page = {}
            }
          }

          data.filters.page.date_historical = {
            'type': 'range',
            'to': args.get('date_to'),
            'from': args.get('date_from'),
          }
        } else {
          // console.log("deleter in initial")
          if (data.filters.page.date_historical) {
            delete data.filters.page.date_historical
          }
        }
        // end intiial query

        // data = this.removeUnusedFilters(data)
      } else {
        // This is for the standard query (used anytime we're not 'initial'). It uses the Vuex store to determine which options to send.
        // factor out into this.buildStandardQuery()
        data = {
          "q": this.searchTerm || (args.has('q') ? args.get('q') : ''),
          // "engine_key": "bBSzVx-LA9Z4yYTf6W-S",
          "per_page" : 100,
          "facets": {
            "page": ["type", "topics", "centuries", "grades"]
          },
          "page" : $this.currentPage,
          "filters": {
            "page": {
              "type": $this.getActiveTypeFilters(),
              "topics": $this.getActiveTopicFilters(),
              "grades": $this.getActiveGradeFilters(),
              "key_person": $this.getActivePersonFilters(),
              "states": $this.getActiveStateFilters(),
              "centuries": $this.getActiveCenturyFilters(),
            }
          },
        }

        if (this.dateFilterTo !== '' || this.dateFilterFrom !== '') {
          if (!data.filters) {
            data.filters = {}

            if (!data.filters.page) {
              data.filters.page = {}
            }
          }
          data.filters.page.date_historical = {
            'type': 'range',
            'from': $this.dateFilterFrom,
            'to': $this.dateFilterTo,
          }
        } else {
          if (data.filters.page.date_historical) {
            delete data.filters.page.date_historical
          }
        }
      }

      data = this.removeUnusedFilters(data)

      this.packageUrl(data)

      // console.log("axios call!")
      // console.log("locking...")
      $this.$store.commit('updateLocked', true)

      // console.log("request: ")
      // console.log(JSON.stringify(data))
      // console.log("end request: ")

      this.axios.post(this.api, data, this.headers)
      .then(function (response) {
        // console.log("axios result!")
        // console.log("...unlocking!")
        $this.$store.commit('updateLocked', false)

        var dataPackage = {}
        dataPackage.currentCount = response.data.record_count
        dataPackage.totalCount = response.data.info.page.total_result_count
        dataPackage.totalPages = response.data.info.page.num_pages
        dataPackage.currentPage = response.data.info.page.current_page

        $this.$store.commit('updateResultsData', dataPackage)
        $this.$store.commit('updateResultsItems', response.data.records.page)
        $this.$store.commit('updateFullResponse', response)
        $this.$store.commit('updateFacets', response.data.info.page.facets)

        if ($this.initial) {
          if (data.filters && data.filters.page) {
            data.filters.page.type ? $this.broadcast('initial-filters-type', data.filters.page.type) : ''
            data.filters.page.topics ? $this.broadcast('initial-filters-topics', data.filters.page.topics) : ''
            data.filters.page.grades ? $this.broadcast('initial-filters-grades', data.filters.page.grades) : ''
            data.filters.page.centuries ? $this.broadcast('initial-filters-centuries', data.filters.page.centuries) : ''
          }

          var theQuery = typeof data.q === 'string' ? data.q : ''
          $this.broadcast('initial-filters-q', theQuery)

          if (data.filters && data.filters.page && data.filters.page.date_historical) {
            $this.broadcast('initial-filters-date-from', data.filters.page.date_historical.from)
            $this.broadcast('initial-filters-date-to', data.filters.page.date_historical.to)
          }
          if (data.filters && data.filters.page && data.filters.page.states) {
            $this.broadcast('initial-state', data.filters.page.states)
          }

          if (data.filters && data.filters.page && data.filters.page.key_person) {
            $this.broadcast('initial-key-person', data.filters.page.key_person)
          }
          setTimeout(() => {
            // @TODO: This was happening before the events were emitting, triggering a second query.
            $this.$store.commit('updateInitial', false)

          }, 500);

        }

        $this.newFacetCounts(data)

        // console.log(response)
      }).catch(function (error) {
        // console.log(error);
      })
    }
  }
};
</script>

<style lang="scss" scoped>
  .Search {
    // width: 1440px;
  }
</style>
